import React, { useState, useEffect, Suspense, useRef } from "react";
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";

import Header from "../website/header";
import { isCommonLoggedIn } from "../../utils";
import "../../assets/common-css.css";

import Service1 from "../../assets/website/images/Service-1.webp";
import Service2 from "../../assets/website/images/Service-2.webp";
import Service3 from "../../assets/website/images/new_car_showroom.webp";
import TestimonialSlider from "../website/testimonialSlide";
import WebsiteAd from "./websiteAd";
import Footer from "../website/footer";

const LazyModalBox = React.lazy(() => import("./modal"));

const useDeferredSection = (rootMargin = "300px") => {
  const sectionRef = useRef(null);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (shouldRender) {
      return undefined;
    }

    const element = sectionRef.current;
    if (!element) {
      return undefined;
    }

    if (typeof window === "undefined" || !("IntersectionObserver" in window)) {
      setShouldRender(true);
      return undefined;
    }

    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldRender(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, [rootMargin, shouldRender]);

  return { sectionRef, shouldRender };
};

const Home = () => {
  const { t } = useTranslation();
  const [loginShow, setLoginShow] = useState(false);
  const handleClose = () => setLoginShow(false);
  const handleShow = () => setLoginShow(true);
  const [corporateShow, setCorporateShow] = useState(false);
  const handleCorporateClose = () => setCorporateShow(false);
  const handleCorporateShow = () => setCorporateShow(true);
  const [calculatedHeightForCarousel, setCalculatedHeightForCarousel] = useState(null);

  const [headerLogin, setHeaderLogin] = useState({});
  useEffect(() => {
    let getHeaderLogin = isCommonLoggedIn();
    setHeaderLogin(getHeaderLogin);
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 100,
      behavior: "auto",
    });
  }, []);

  const sliderImages = [
    `${process.env.PUBLIC_URL}/Slider_1.webp`,
    `${process.env.PUBLIC_URL}/Slider_2.webp`,
    `${process.env.PUBLIC_URL}/Slider_3.webp`,
  ];
  const testimonialSection = useDeferredSection("350px");
  const websiteAdSection = useDeferredSection("350px");
  const footerSection = useDeferredSection("500px");

  useEffect(() => {
    updateCarouselHeight();
  }, []);

  const updateCarouselHeight = () => {
    const slideContentEle = document.querySelector(".SlideContent");
    if(slideContentEle){
      const height = slideContentEle.clientHeight;
      setCalculatedHeightForCarousel(height);
    }
  }

  return (
    <>
      <Header />

      { loginShow && 
      <Suspense fallback={<div></div>}>
        <LazyModalBox
          loginShow={loginShow}
          handleClose={handleClose}
          handleShow={handleShow}
          corporateShow={corporateShow}
          handleCorporateClose={handleCorporateClose}
          handleCorporateShow={handleCorporateShow}
          aciveShow={false}
        />  
      </Suspense>
      }
      {corporateShow && !loginShow &&
      <Suspense fallback={<div></div>}>
        <LazyModalBox
          loginShow={loginShow}
          handleClose={handleClose}
          handleShow={handleShow}
          corporateShow={corporateShow}
          handleCorporateClose={handleCorporateClose}
          handleCorporateShow={handleCorporateShow}
          aciveShow={false}
        />
      </Suspense>
      }

<div className="SliderAreaWrapper">
    {/* Left side - Slider */}
    <div className="SliderArea" style={calculatedHeightForCarousel && {height: calculatedHeightForCarousel}} >
    <div id="Slide" className="carousel slide" data-ride="carousel">
          {/* <ul className="carousel-indicators carousel_indicator_mvp">
            <li data-target="#Slide" data-slide-to="0" className="active"></li>
            <li data-target="#Slide" data-slide-to="1"></li>
            <li data-target="#Slide" data-slide-to="2"></li>
            <li data-target="#Slide" data-slide-to="3"></li>
          </ul> */}
          <div className="carousel-inner">
            {sliderImages.map((i, idx)=>{
              return <div className={`carousel-item ${idx === 0 && 'active'}`} key={i}>
              <img
                alt=""
                src={i}
                height={calculatedHeightForCarousel}
                width="870"
                loading={idx === 0 ? "eager" : "lazy"}
                fetchpriority={idx === 0 ? "high" : "low"}
                decoding="async"
              />
            </div>
            })}
          </div>
          <a className="carousel-control-prev" href="#Slide" data-slide="prev">
            <i className="fa fa-angle-left"></i>
          </a>
          <a className="carousel-control-next" href="#Slide" data-slide="next">
            <i className="fa fa-angle-right"></i>
          </a>
        </div>
    </div>
     {/* Right side - Slide Content */}
    <div className="SlideContent slider_text_hide_mvp">
      <div className="public-portal">
      <h3> {t("website.home.Allyourautomotiveneedsinoneplace")} </h3>
          <p>{t("website.home.Ourvehiclesareoneofthemost")}</p>
          <ul>
            <li>
              <Link to="/auto-repair">{t("website.home.AutoRepair")}</Link>
            </li>
            <li>
              <Link to="/auto-parts">{t("website.home.AutoParts")}</Link>
            </li>
            <li>
              <Link to="/auto-sales">{t("website.home.AutoSales")}</Link>
            </li>
            <li>
              <Link to="/auto-services">{t("website.home.AutoServices")}</Link>
            </li>
          </ul>
      </div>
    <div className="corporatePortal">
      <img
        src={`${process.env.PUBLIC_URL}/corporate.webp`}
        alt="Corporate Portal"
        onLoad={updateCarouselHeight}
        width="700"
        height="280"
        loading="eager"
        fetchpriority="high"
        decoding="async"
      />
      <h3>{t("website.home.CorporatePortal")}</h3>
      <div className="buttons">
        <Link to={"/signup/corporate"} className="btn-gray">{t("website.footer.Register")}</Link>
        <button className="btn-red" onClick={handleCorporateShow} >{t("website.footer.Login")}</button>
      </div>
    </div>
        
        </div>
   
</div>

    {/*      
      <div className="need_help">
        <h3> {t("website.home.NeedHelpWithYourVehicle")} </h3>
        <h6> {t("website.home.SelectButtonService")} </h6>
        <div className="need_help_btn_group">
          <span className="need_help_btn">
            <Link to="/auto-repair">{t("website.home.AutoRepair")}</Link>
          </span>
          <span className="need_help_btn">
            {" "}
            <Link to="/auto-parts">{t("website.home.AutoParts")}</Link>
          </span>
          <span className="need_help_btn">
            <Link to="/auto-sales">{t("website.home.AutoSales")}</Link>
          </span>
        </div>
      </div> */}
      <section>
        <div className="ServiceArea">
          <div className="container">
            <h3> {t("website.home.Areyouanautoserviceprovider?")} </h3>
            <p className="ServiceArea-container-heading-para">{t("website.home.AccelerateYourBusiness")}</p>
            <div className="row">
              <div className="col-sm-4">
                <div className="ServiceBox">
                  <figure>
                    <img alt="" src={Service1} width="360" height="240" loading="lazy" decoding="async" />
                  </figure>
                  <figcaption>
                    <h4> {t("website.home.GarageOwners&TowTrucks")} </h4>
                    <aside>
                      <p> {t("website.home.Foradditionalinformation")} </p>
                    </aside>
                    <article className={headerLogin && Object.keys(headerLogin || {}).length > 0 ? "single-btn-container" : ""}>
                      {headerLogin &&
                      Object.getOwnPropertyNames(headerLogin).length != 0 ? (
                        <Link to="/service-auto-repair">
                          {" "}
                          {t("website.home.Moreinfo")}{" "}
                        </Link>
                      ) : (
                        <>
                          <Link to="/service-auto-repair">
                            {t("website.home.Moreinfo")}
                          </Link>
                          <Link to="" onClick={handleShow}>
                            {t("website.home.Login")}
                          </Link>
                        </>
                      )}
                    </article>
                  </figcaption>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="ServiceBox">
                  <figure>
                    <img alt="" src={Service2} width="360" height="240" loading="lazy" decoding="async" />
                  </figure>
                  <figcaption>
                    <h4> {t("website.home.AutoPartsVendors")} </h4>
                    <aside>
                      <p> {t("website.home.Autowizisincontact")} </p>
                    </aside>
                    <article className={headerLogin && Object.keys(headerLogin || {}).length > 0 ? "single-btn-container" : ""}>
                      {headerLogin &&
                      Object.getOwnPropertyNames(headerLogin).length != 0 ? (
                        <Link to="/service-auto-parts">
                          {t("website.home.Moreinfo")}
                        </Link>
                      ) : (
                        <>
                          <Link to="/service-auto-parts">
                            {t("website.home.Moreinfo")}
                          </Link>
                          <Link to="" onClick={handleShow}>
                            {t("website.home.Login")}
                          </Link>
                        </>
                      )}
                    </article>
                  </figcaption>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="ServiceBox">
                  <figure>
                    <img alt="" src={Service3} width="360" height="240" loading="lazy" decoding="async" />
                  </figure>
                  <figcaption>
                    <h4> {t("website.home.AutoSalesdealers")} </h4>
                    <aside>
                      <p>{t("website.home.Ifyouareinthemarket")}</p>
                    </aside>
                    <article className={headerLogin && Object.keys(headerLogin || {}).length > 0 ? "single-btn-container" : ""}>
                      {headerLogin &&
                      Object.getOwnPropertyNames(headerLogin).length != 0 ? (
                        <Link to="/service-auto-sales">
                          {t("website.home.Moreinfo")}
                        </Link>
                      ) : (
                        <>
                          <Link to="/service-auto-sales">
                            {t("website.home.Moreinfo")}
                          </Link>
                          <Link to="" onClick={handleShow}>
                            {t("website.home.Login")}
                          </Link>
                        </>
                      )}
                    </article>
                  </figcaption>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div ref={testimonialSection.sectionRef}>
        {testimonialSection.shouldRender ? (
          <TestimonialSlider />
        ) : (
          <div style={{ minHeight: "420px" }} aria-hidden="true" />
        )}
      </div>
      <div ref={websiteAdSection.sectionRef}>
        {websiteAdSection.shouldRender ? (
          <WebsiteAd />
        ) : (
          <div style={{ minHeight: "380px" }} aria-hidden="true" />
        )}
      </div>
      <div ref={footerSection.sectionRef}>
        {footerSection.shouldRender ? (
          <Footer />
        ) : (
          <div style={{ minHeight: "520px" }} aria-hidden="true" />
        )}
      </div>
    </>
  );
};

export default Home;
